module.exports = __webpack_public_path__ + "static/media/laptop-mobile-icon.8b3e86f0.png";